import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Connects to data-controller="tomselect"
export default class extends Controller {
  static get targets() {
    return ['select']
  }

  static get values() {
    return { plugins: Array }
  }

  connect() {
    const options = { maxOptions: null }
    if (this.hasPluginsValue && this.pluginsValue.length) {
      options.plugins = this.pluginsValue
    }
    // eslint-disable-next-line no-new
    new TomSelect(this.selectTarget, options)
  }

  disconnect() {
    this.selectTarget.tomselect?.destroy()
  }
}
